// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskCompletionMinLevelsEffectiveAnyOf } from './taskCompletionMinLevelsEffectiveAnyOf';

/**
 * Effective per-dimension min levels after applying override or module default
 */
export type TaskCompletionMinLevelsEffective = TaskCompletionMinLevelsEffectiveAnyOf | null;
